import "./admin/licence";
import "./admin/style.scss";
// import { Chart } from "chart.js";
(function ($) {
  $(document).ready(function () {
    //Import Data
    $(".h5vp_import_data").on("click", function (e) {
      e.preventDefault();
      $.ajax({
        url: h5vpAdmin?.ajaxUrl,
        data: {
          action: "h5vp_import_data_ajax",
        },
        success: function (data) {
          const result = JSON.parse(data);
          if (result?.success === true) {
            location.href = location.href + "?h5ap-import=success";
          }
        },
      });
    });

    // Codestar metabox controller
    $(".h5vp_player_type .csf-fieldset .csf--button-group .csf--button").on("click", function () {
      setTimeout(() => {
        $(".h5vp_player_type_controls").addClass("h5vp_player_controls_click_trigger newclassbro");
        $(".h5vp_player_controls_click_trigger").removeClass("h5vp_player_type_controls");
        const playerType = $(this).parent(".csf--button-group").find(".csf--active input").val();
        $('.h5vp_player_controls_click_trigger .csf-fieldset .csf--button-group .csf--button input[value="' + playerType + '"]')
          .parent()
          .trigger("click");

        $(".h5vp_player_controls_click_trigger").removeClass("h5vp_player_controls_click_trigger");
      }, 100);
      setTimeout(() => {
        $(".newclassbro").addClass("h5vp_player_type_controls");
      }, 1000);
    });

    $(".h5vp_player_type_controls .csf-fieldset .csf--button-group .csf--button").on("click", function () {
      setTimeout(() => {
        $(".h5vp_player_type").addClass("h5vp_player_click_trigger");
        $(".h5vp_player_controls_click_trigger").removeClass("h5vp_player_type");
        const playerType = $(this).parent(".csf--button-group").find(".csf--active input").val();
        $('.h5vp_player_click_trigger .csf-fieldset .csf--button-group .csf--button input[value="' + playerType + '"]')
          .parent()
          .trigger("click");
        $(".h5vp_player_click_trigger").removeClass("h5vp_player_click_trigger");
      }, 100);
      setTimeout(() => {
        $(".h5vp_player_click_trigger").addClass("h5vp_player_type");
      }, 1000);
    });

    //duplicate player
    $(".h5vp_duplicate_player").on("click", function (event) {
      event.preventDefault();
      $.post(
        h5vpAdmin.ajaxUrl,
        {
          action: "h5vp_dulicate_player",
          postid: $(this).data("postid"),
          security: $(this).attr("security"),
        },
        function (data) {
          if (data) {
            let location = window.location.href;
            if (location.split("?").length > 1) {
              location = location + "&duplicate=success";
            } else {
              location = location + "?duplicate=success";
            }
            window.location.href = location;
          }
        }
      );
    });

    let url = window.location.href;
    let newUrl = url.search("duplicate=success");
    if (newUrl != "-1") {
      window.history.pushState({ urlPath: "edit.php?post_type=videoplayer" }, "", "edit.php?post_type=videoplayer");
    }

    //shortcode copier
    $(document).on("click", ".h5vp_front_shortcode input", function (e) {
      e.preventDefault();

      let shortcode = $(this).parent().find("input")[0];
      shortcode.select();
      shortcode.setSelectionRange(0, 30);
      document.execCommand("copy");
      $(this).parent().find(".htooltip").text("Copied Successfully!");
    });

    $(document).on("mouseout", ".h5vp_front_shortcode input", function () {
      $(this).parent().find(".htooltip").text("Copy To Clipboard");
    });

    // show/hide password in protected field
    $(".h5vp_show_password").on("click", function () {
      let type = $(this).parent().find("input").attr("type");
      if (type == "password") {
        $(this).parent().find("input").attr("type", "text");
      } else {
        $(this).parent().find("input").attr("type", "password");
      }
    });

    //redirect user page when click on user tr
    $(".h5vp-analytics table tr").on("click", function () {
      if (this.getAttribute("to")) {
        location.href = location.href.match(/(.+)&page=analytics/g)[0] + `&${this.getAttribute("to")}`;
      }
    });

    //initialize chart
    const chart = document.getElementById("myChart");
    // const labels = ["January", "February", "March", "April", "May", "June"];
    const labels = chart && chart.getAttribute("data-labels") && JSON.parse(chart.getAttribute("data-labels"));
    const value = chart && chart.getAttribute("data-data") && JSON.parse(chart.getAttribute("data-data"));
    const data = {
      labels: labels,
      datasets: [
        {
          label: "Views",
          backgroundColor: "rgb(255, 99, 132)",
          borderColor: "rgb(255, 99, 132)",
          color: "rgb(255, 99, 132)",
          data: value,
          tension: 0.4,
        },
      ],
    };
    const config = {
      type: "line",
      data: data,
      options: {},
      plugins: [
        {
          id: chart && chart.getAttribute("id"),
          beforeDraw: (chart) => {
            const ctx = chart.canvas.getContext("2d");
            ctx.save();
            ctx.globalCompositeOperation = "destination-over";
            ctx.fillStyle = "#fff";
            // ctx.
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
          },
        },
      ],
    };
    if (chart) {
      var myChart = new Chart(chart, config);
      chart.setAttribute("data-labels", "");
      chart.setAttribute("data-data", "");
      myChart.fillStyle = "#fff";
      console.log(myChart);
    }
    //ready end

    //convert srt file
    const convertButton = document.getElementById("h5vp_srt_convert_button");

    if (convertButton) {
      convertButton.onclick = async (e) => {
        e.preventDefault();
        const srtFile = document.getElementById("h5vp_srt_file").value;
        const result = await fetch(srtFile);
        const blob = await result.blob();
        if (blob) {
          var reader = new FileReader();
          reader.readAsText(blob, "UTF-8");
          reader.onload = function (evt) {
            const content = srt2webvtt(evt.target.result);
            // console.log(content);
            download(
              srtFile
                .substring(srtFile.lastIndexOf("/") + 1)
                .split(".")
                .slice(0, -1)
                .join(".") + ".vtt",
              content
            );
            document.getElementById("h5vp_srt_file").value = "";
          };
          reader.onerror = function (evt) {};
        }
      };
    }

    function srt2webvtt(data) {
      // remove dos newlines
      var srt = data.replace(/\r+/g, "");
      // trim white space start and end
      srt = srt.replace(/^\s+|\s+$/g, "");

      // get cues
      var cuelist = srt.split("\n\n");
      var result = "";

      if (cuelist.length > 0) {
        result += "WEBVTT\n\n";
        for (var i = 0; i < cuelist.length; i = i + 1) {
          result += convertSrtCue(cuelist[i]);
        }
      }

      return result;
    }

    function convertSrtCue(caption) {
      // remove all html tags for security reasons
      //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');

      var cue = "";
      var s = caption.split(/\n/);

      // concatenate muilt-line string separated in array into one
      while (s.length > 3) {
        for (var i = 3; i < s.length; i++) {
          s[2] += "\n" + s[i];
        }
        s.splice(3, s.length - 3);
      }

      var line = 0;

      // detect identifier
      if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
        cue += s[0].match(/\w+/) + "\n";
        line += 1;
      }
      // return s[line];

      // get time strings
      if (s[line].match(/\d+:\d+:\d+/)) {
        // convert time string
        var m = s[line].match(/(\d+):(\d+):(\d+)(?:,?\.?(\d+))?\s*-?-?>?,?\s*(\d+):(\d+):(\d+)(?:,?\.?(\d+))?/);
        // var m = s[line].match(/(\d+):(\d+):(\d+)(?:,?.?(\d+))?\s*-?-?>?,?\s*(\d+):(\d+):(\d+)(?:,?.?(\d+))?/);
        if (m) {
          cue += m[1] + ":" + m[2] + ":" + m[3] + "." + m[4] + " --> " + m[5] + ":" + m[6] + ":" + m[7] + "." + m[8] + "\n";
          line += 1;
        } else {
          // Unrecognized timestring
          return "";
        }
      } else {
        // file format error or comment lines
        return "";
      }

      // get cue text
      if (s[line]) {
        cue += s[line];
        if (s[line + 1]) {
          cue += "\n";
          cue += s[line + 1] + "\n\n";
        } else {
          cue += "\n\n";
        }
      }
      return cue;
    }

    function download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }

    const exportButtons = document.querySelectorAll(".h5vp_export_button");
    Object.values(exportButtons).map((item) => {
      const id = item.dataset.id;
      item.addEventListener("click", function (e) {
        e.preventDefault();
        $.ajax({
          url: h5vpAdmin?.ajaxUrl,
          data: {
            action: "h5vp_export_data",
            id,
          },
          method: "POST",
          success: function (result) {
            const url = window.URL.createObjectURL(new Blob([result], { type: "application/json" }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `playlist-${id}.json`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            try {
              console.log({ result: JSON.parse(result) });
            } catch (error) {
              console.log({ result });
            }
          },
        });
      });
    });

    //import better

    const formWrapper = document.querySelector(".h5vp_import_form");
    const form = formWrapper?.querySelector("form");
    const closeBtn = formWrapper?.querySelector(".close");
    const notice = formWrapper?.querySelector(".h5vp-import-notice");
    closeBtn?.addEventListener("click", function () {
      formWrapper.style.display = "none";
    });

    form?.addEventListener("submit", function (e) {
      e.preventDefault();
      const fileInput = form.querySelector(".h5vp_import_file");
      if (fileInput.files[0]) {
        var reader = new FileReader();
        reader.readAsText(fileInput.files[0], "UTF-8");
        reader.onload = function (e) {
          const content = e.target.result;
          $.ajax({
            url: h5vpAdmin?.ajaxUrl,
            data: {
              action: "h5vp_import_data",
              id,
              content,
            },
            method: "POST",
            success: function (result) {
              console.log({ result });
              notice.style.display = "block";
              fileInput.value = "";
              setTimeout(() => {
                if (window.importReload) {
                  window.location.reload();
                }
                formWrapper.style.display = "none";
              }, 1000);
            },
          });
        };
        reader.onerror = function () {
          console.log("error importing");
        };
      }
    });

    const importButtons = document.querySelectorAll(".h5vp_import_button");
    Object.values(importButtons).map((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        window.id = item.dataset.id;
        window.importReload = item.dataset.reload;
        notice.style.display = "none";
        formWrapper.style.display = "block";
      });
    });
  });
})(jQuery);

export function setCookie(cookieName, cookieValue, expiryInSeconds) {
  var expiry = new Date();
  expiry.setTime(expiry.getTime() + 1000 * expiryInSeconds);
  document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expiry.toGMTString() + ";path=/";
}
